module.exports = {
    allRemotePreferences: [ 'On site', 'Hybrid', 'Remote'],
    default: 'On site',
}